/** @format */

import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { Container } from "react-bootstrap";
import { login } from "../../../Features/AuthSlice";
import { closeModal } from "../../../Features/ViewSlice";
import CreateNewPassword from "./CreateNewPassword";
import ForgotPassword from "./ForgotPassword";
import PasswordSuccess from "./PasswordSuccess";
import OTPVerification from "./OTPVerification";
import LoginForm from "./LoginForm";
import Modal from "../Modal/Modal";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const loginModal = useSelector((state) => state.view.modalState.loginView);
  const loginViews = useSelector((state) => state.view.loginInStates);

  const [isChecked, setIsChecked] = useState(false);
  const [logindetails, setlogindetails] = useState({
    email: "",
    password: "",
    rememberme: false,
  });

  const handleCheckbox = () => setIsChecked(!isChecked);

  const handleChange = (e) => {
    if (e.target.name === "checkbox") {
      setlogindetails({ ...logindetails, [e.target.name]: e.target.checked });
      return;
    }
    setlogindetails({ ...logindetails, [e.target.name]: e.target.value });
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    const email = logindetails.email;
    const password = logindetails.password;

    dispatch(login({ email, password })).then((res) => {
      if (res.payload?.status === 200) {
        const userData = res.payload.data;

        // ✅ Store agency info if active
        if (userData.data.agency && userData.data.agency.length > 0) {
          const activeAgency = userData.data.agency.find(
            (agency) => agency.status === "active",
          );

          if (activeAgency) {
            const fullLogoUrl = `https://secureadmin.lkwb.com.np/storage/${activeAgency.logo}`;

            localStorage.setItem("agencyLogo", fullLogoUrl);
            localStorage.setItem("agencyName", activeAgency.name);
            localStorage.setItem("agencyPhone", activeAgency.phone || "");
            localStorage.setItem("agencyAddress", activeAgency.address || "");
            localStorage.setItem("agencyEmail", activeAgency.email || "");
          } else {
            // Clear if no active agency
            localStorage.removeItem("agencyLogo");
            localStorage.removeItem("agencyName");
            localStorage.removeItem("agencyPhone");
            localStorage.removeItem("agencyAddress");
            localStorage.removeItem("agencyEmail");
          }
        } else {
          // Clear if user has no agency
          localStorage.removeItem("agencyLogo");
          localStorage.removeItem("agencyName");
          localStorage.removeItem("agencyPhone");
          localStorage.removeItem("agencyAddress");
          localStorage.removeItem("agencyEmail");
        }

        dispatch(closeModal());
        navigate("/dashboard"); // Redirect to dashboard
      }
    });
  };

  return (
    <>
      {loginModal && (
        <div className="loginFormContainer defaultInputs">
          <Container>
            <Modal size="lg">
              {loginViews.viewLoginForm && (
                <LoginForm
                  handleChange={handleChange}
                  handleSubmit={handleLogin}
                  handleCheckbox={handleCheckbox}
                />
              )}
              {loginViews.viewOTP && <OTPVerification />}
              {loginViews.viewForgotPassword && <ForgotPassword />}
              {loginViews.viewNewPassword && <CreateNewPassword />}
              {loginViews.viewPasswordSuccess && <PasswordSuccess />}
            </Modal>
          </Container>
        </div>
      )}
    </>
  );
};

export default Login;
